import * as React from 'react';

const ShareIcon = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={19}
      height={19}
      viewBox="0 0 19 19"
      fill="none"
      {...props}
    >
      <path
        d="m7.9 14.93 2.958 2.945a1.493 1.493 0 0 0 1.425.407 1.519 1.519 0 0 0 1.1-1.004L18.24 2.716A1.52 1.52 0 0 0 16.287.76L1.723 5.62A1.52 1.52 0 0 0 .72 6.787a1.493 1.493 0 0 0 .407 1.357l3.719 3.719-.122 4.709 3.175-1.642Zm9.906-13.87L4.846 11.864"
        stroke="#717171"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default ShareIcon;
